import cn from '@/lib/cs';
import React from 'react';

const CloseIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 22"
		className={cn('h-8 lg:h-12 pointer-events-none', className)}
		{...props}
	>
		<path
			fill="currentColor"
			d="M15.381 11.672c-.532-.478-.154-1.13.386-1.6l3.372-2.936c.363-.316.703-.659 1.018-1.024l.957-1.115c.431-.501.91-.966 1.319-1.485.23-.292.46-.608.638-.853v-.003l-.338-1.54a1.17 1.17 0 00-1.367-.895l-.718.14c-.408.08-.78.29-1.054.603-.504.578-.723.87-.943 1.161-.273.364-.546.727-1.368 1.64l-2.24 2.055-1.202 1.104a.839.839 0 01-1.15-.015 251.51 251.51 0 01-1.777-1.737 10.172 10.172 0 00-1.687-1.345l-1.556-.99C6.093 1.835 4.866.766 3.2.282L3.002.225a1.303 1.303 0 00-1.322.37c-.246.266-.382.626-.309.982.214 1.042.778 1.406 1.73 2.185L5.61 5.817 8.12 7.87a2.573 2.573 0 01.113 4.19l-2.607 1.967a4.82 4.82 0 00-.528.46L3.4 16.2a8.153 8.153 0 01-.98.826 12 12 0 00-1.35 1.142c-.712.7-.926 1.748-.68 2.716l.242.952a.183.183 0 00.208.136 8.957 8.957 0 004.648-2.335l.33-.312c.675-.639 1.35-1.277 2.297-2.19l2.585-2.056 1.488-1.183a.826.826 0 011.13.095c.497.556.99 1.11 1.477 1.666.487.553 1.03 1.054 1.625 1.49l1.248.915c1.444 1.059 2.998 3.093 4.68 3.656l.054.018a1.19 1.19 0 001.308-.387c.186-.233.278-.527.258-.824l-.015-.24a2.027 2.027 0 00-.52-1.223l-.535-.6a16.52 16.52 0 00-1.27-1.324l-2.175-2.055-2.174-2.054c-.332-.258-1.303-.82-1.899-1.357z"
		/>
	</svg>
);

export default CloseIcon;
